import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import locale from 'element-ui/lib/locale'
import enLocale from './en'
import zhLocale from './zh'
import {getStore} from '@/utils/store'
Vue.use(VueI18n)

// route中的中英文是菜单管理中配置的，需要从后台获取（在@/views/layout/index mounted方法中从后台获取数据）
enLocale.route = getStore({
  name: 'menus-lang_en'
})
zhLocale.route = getStore({
  name: 'menus-lang_zh'
})

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  }
}

const i18n = new VueI18n({
  // set locale
  // options: en or zh
  locale: Cookies.get('language') || 'zh',
  // set locale messages
  messages
})
locale.i18n((key, value) => i18n.t(key, value)) // 重点：为了实现element插件的多语言切换
export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js